import { getActiveLanguageStringComparator } from './localeStringComparator';

export function getStringPropertyComparator<T>(
    field: keyof T,
    localeStringComparator = getActiveLanguageStringComparator(),
) {
    return (a: T, b: T) => localeStringComparator(
        a[field] != null ? String(a[field]) : undefined,
        b[field] != null ? String(b[field]) : undefined,
    );
}
